module.exports = __webpack_public_path__ + "img/antimationBg.9cd95fe3.png";